// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListMinimalEmployeesQueryVariables = Types.Exact<{
  pageNumber: Types.Scalars['Int']['input'];
  pageSize: Types.Scalars['Int']['input'];
  filter: Types.InputMaybe<Types.ListEmployeesFilterInput>;
  sort: Types.InputMaybe<Array<Types.ListEmployeesSortInput> | Types.ListEmployeesSortInput>;
}>;

export type ListMinimalEmployeesQuery = { __typename?: 'Query' } & {
  listEmployees: { __typename?: 'ListEmployees' } & Pick<Types.ListEmployees, 'totalCount'> & {
      items: Array<
        { __typename?: 'Employee' } & Pick<Types.Employee, 'id'> & {
            generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
              Types.EmployeeGeneralInformation,
              'preferredFullName' | 'legalFullName'
            >;
            currentMainContract: Types.Maybe<
              { __typename?: 'EmployeeContract' } & {
                company: { __typename?: 'Company' } & Pick<Types.Company, 'countryId'>;
              }
            >;
          }
      >;
    };
};

export const ListMinimalEmployeesDocument = /*#__PURE__*/ gql`
    query listMinimalEmployees($pageNumber: Int!, $pageSize: Int!, $filter: ListEmployeesFilterInput, $sort: [ListEmployeesSortInput!]) {
  listEmployees(
    pageNumber: $pageNumber
    pageSize: $pageSize
    filter: $filter
    sort: $sort
  ) {
    items {
      id
      generalInformation {
        preferredFullName
        legalFullName
      }
      currentMainContract {
        company {
          countryId
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListMinimalEmployeesQuery__
 *
 * To run a query within a React component, call `useListMinimalEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMinimalEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMinimalEmployeesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListMinimalEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables> &
    ({ variables: ListMinimalEmployeesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>(
    ListMinimalEmployeesDocument,
    options,
  );
}
export function useListMinimalEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>(
    ListMinimalEmployeesDocument,
    options,
  );
}
// @ts-expect-error
export function useListMinimalEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>;
export function useListMinimalEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListMinimalEmployeesQuery | undefined, ListMinimalEmployeesQueryVariables>;
export function useListMinimalEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMinimalEmployeesQuery, ListMinimalEmployeesQueryVariables>(
    ListMinimalEmployeesDocument,
    options,
  );
}
export type ListMinimalEmployeesQueryHookResult = ReturnType<typeof useListMinimalEmployeesQuery>;
export type ListMinimalEmployeesLazyQueryHookResult = ReturnType<typeof useListMinimalEmployeesLazyQuery>;
export type ListMinimalEmployeesSuspenseQueryHookResult = ReturnType<typeof useListMinimalEmployeesSuspenseQuery>;
